var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPlatform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 128,
    viewBox: "0 0 352 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5702_64550)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.889 28.4443C139.986 28.4443 136 32.4304 136 37.3332V77.3332C136 82.236 139.986 86.2221 144.889 86.2221H207.111C212.014 86.2221 216 82.236 216 77.3332V37.3332C216 32.4304 212.014 28.4443 207.111 28.4443H144.889ZM207.111 37.3332V68.4443H144.889V37.3332H207.111Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.111 37.3333H144.889V68.4444H207.111V37.3333ZM193.778 90.6666H184.153L182.667 86.2221H169.333L167.847 90.6666H158.222C155.764 90.6666 153.778 92.6527 153.778 95.111C153.778 97.5694 155.764 99.5555 158.222 99.5555H193.778C196.236 99.5555 198.222 97.5694 198.222 95.111C198.222 92.6527 196.236 90.6666 193.778 90.6666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5702_64550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 71.1111,
    fill: "white",
    transform: "translate(136 28.4443)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlatform);
export default __webpack_public_path__ + "static/media/icon-platform.1649149ae812e9cc63caf66c3a96d8be.svg";
export { ForwardRef as ReactComponent };